import $ from 'jquery';

import BaseController from 'chairisher/_controller';

import bindProfileAnalytics from 'chairisher/analytics/profile';

import { logAmplitudeLinkClickEvent, ShopPosition } from 'chairisher/util/analytics';

/**
 * Controller which binds actions for the business article list view.
 */
class BusinessArticlePortfolioController extends BaseController {
    bindPageAnalytics() {
        super.bindPageAnalytics();

        bindProfileAnalytics('screen - news');

        $('[data-action-type=view_on_website]').on('click', ({ currentTarget }) => {
            const $link = $(currentTarget);

            logAmplitudeLinkClickEvent($link.text().trim(), $link.attr('href'), ShopPosition.NEWS_RAIL);
        });
    }
}

export default BusinessArticlePortfolioController;
